<template>
  <div v-show="isLoaded" class="dRitualRed-container" v-observe-visibility="startAnimate">
    <div class="dRitualRed-title">
      <h2 class="title" :class="{animate: animate}">Ritual del Servido</h2>
    </div>
    <img class="dRitualRed-fresas" v-observe-visibility="startAnimate" :src="fresa" :class="{animate: animate}" alt="Fresas">
    <div class="dFlex-container">
      <div class="dImagen Imagen-1" :class="{animate: animate}">
        <img class="" :src="paso1" alt="Paso 1">
      </div>
      <div class="dImagen Imagen-2" :class="{animate: animate}">
        <img class="" :src="paso2" alt="Paso 2">
      </div>
      <div class="dImagen Imagen-3" :class="{animate: animate}">
        <img class="" :src="paso3" alt="Paso 3">
      </div>
    </div>
  </div>
</template>

<script>
import fresa from '@/assets/red-berries/fresas.png';
import paso1 from '@/assets/red-berries/1REDBERRIES.png';
import paso2 from '@/assets/red-berries/2REDBERRIES.png';
import paso3 from '@/assets/red-berries/3REDBERRIES.png';
import { mapGetters } from "vuex";
import Bowser from "bowser";

export default {
  name: "D_RitualRed",
  data() {
    return {
      fresa,
      paso1,
      paso2,
      paso3,
      animate: false,
      isSafari: false,
    };
  },
  computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible) {
      if(isVisible) {
        this.animate=true
      }
    }
  },
  components: {},
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/RedBerries/D_RitualRed.scss";
</style>